module.exports = __webpack_public_path__ + "static/hubspot-006b5ddf3dae2292c44184ee93348b8a.png";